import React,{useState,useEffect} from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import IconBtn from '../../common/IconBtn';
import { useSelector } from 'react-redux';
import {IoIosArrowBack} from "react-icons/io";
import {BsChevronDown} from "react-icons/bs";
import { useDispatch } from 'react-redux';
import { setSidebar } from '../../../slices/profileSlice';


const VideoDetailsSidebar=({setReviewModal})=>{

    const dispatch=useDispatch();


    const navigate=useNavigate();
    const location=useLocation();

    const { courseEntireData,
            completedLectures,
            totalNoOfLectures,
            courseSectionData
        }=useSelector((state)=>state.viewCourse);
    
    const {showSidebar}=useSelector((state)=>state.profile)
    
        const {sectionId,subSectionId}=useParams();

    const [activeStatus,setActiveStatus]=useState("");
    const [videoBarActive,setVideoBarActive]=useState("");

    useEffect(()=>{

       

        ;(()=>{
            console.log("CourseEntireData:",courseEntireData);
            if(!courseSectionData.length) return;
            const currentSectionIdx=courseSectionData.findIndex(
                (data)=>data._id===sectionId
            )
            const currentSubSectionIdx=courseSectionData?.[
                currentSectionIdx
            ]?.subSection.findIndex((data)=>data._id===subSectionId)

            const activeSubSectionId=
                  courseSectionData[currentSectionIdx]?.subSection?.[
                    currentSubSectionIdx
                  ]?._id
            setActiveStatus(courseSectionData?.[currentSectionIdx]?._id)
            setVideoBarActive(activeSubSectionId)
        })()
    },[courseSectionData,courseEntireData,location.pathname])
    

    return (
        <div className={`flex h-[calc(100vh-3.5rem)] w-[320px] max-w-[350px] flex-col border-r-[1px] border-r-richblack-700 bg-richblack-800 ${showSidebar ? "block" : "hidden"} md:block`}>
            <div className="mx-5 flex flex-col items-start justify-between gap-2 gap-y-4 border-b border-richblack-600 py-5 text-lg font-bold text-richblack-25">
                <div className="flex w-full items-center justify-between ">
                    <div
                    onClick={()=>{
                        navigate(`/dashboard/enrolled-courses`)
                    }}
                    className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-richblack-100 p-1 text-richblack-700 hover:scale-90"
                    title="back"
                    >
                    <IoIosArrowBack size={30}/>
                    </div>
                    <IconBtn 
                    text="Add Review"
                    customClasses="ml-auto"
                    onClick={()=>setReviewModal(true)}
                    />
                </div>
                <div className="flex flex-col">
                    <p>{courseEntireData?.courseName}</p>
                    <p className="text-sm font-semibold text-richblack-500">{completedLectures?.length} / {totalNoOfLectures}</p>
                </div>
            </div>

            <div className="h-[calc(100vh - 5rem)] overflow-y-auto">
                {
                    courseSectionData.map((course,index)=>{
                        return <div
                        onClick={()=>{
                        setActiveStatus(course?._id)
                        console.log("setActiveStatus clicked")
                        }}
                        key={index}
                        >
                        {/*Section1*/}
                        <div className="flex flex-row justify-between bg-richblack-600 px-5 py-4 text-richblack-5">
                          <div className="w-[70%] font-semibold">
                            {course?.sectionName}
                          </div>
                          <div className="flex items-center gap-3">
                            <span
                            className={`${activeStatus===course?.sectionName ? "rotate-0" : "rotate-180"} transition-all duration-500`}
                            >
                            <BsChevronDown />
                            </span>
                          </div>
                        </div>

                        {/*Sub Sections*/}
                        {
                            activeStatus===course?._id && (
                                <div className="transition-[height] duration-500 ease-in-out">
                                    {
                                        course.subSection.map((topic,i)=>{
                                            return <div
                                            className={`flex gap-3 px-5 py-2 text-richblack-5 ${
                                                videoBarActive===topic._id
                                                ? "bg-yellow-200 font-semibold text-richblack-800"
                                                : "hover:bg-richblack-900"
                                            }`}

                                            key={i}
                                            onClick={()=>{
                                                navigate(
                                                    `/view-course/${courseEntireData?._id}/section/${course?._id}/sub-section/${topic?._id}` 
                                                )
                                                setVideoBarActive(topic._id)
                                            }}
                                            >

                                            <input 
                                                type="checkbox"
                                                checked={completedLectures.includes(topic?._id)}
                                                onChange={()=>{}}
                                            />
                                            {topic.title}
                                            </div>
                                        })
                                    }
                                </div>
                            )
                        }


                        </div>
                    })
                }
            </div>

        </div>
    )
}

export default VideoDetailsSidebar;